import {
  ActionIcon,
  Badge,
  Box,
  Button,
  Flex,
  Input,
  Menu,
  Title,
  Tooltip,
  rem,
  MultiSelect,
  Group,
  MultiSelectProps,
  Select,
  Loader,
  ComboboxItem,
} from "@mantine/core";
import { modals } from "@mantine/modals";
import {
  IconActivity,
  IconBuildingWarehouse,
  IconCaretDown,
  IconEdit,
  IconEye,
  IconFileExport,
  IconFileUpload,
  IconHandStop,
  IconPlus,
  IconSwitch,
  IconTrash,
  IconX,
  IconZoomReset,
} from "@tabler/icons-react";
import {
  MRT_ColumnDef,
  MRT_RowSelectionState,
  MantineReactTable,
  useMantineReactTable,
} from "mantine-react-table";
import * as React from "react";
import { useEffect, useState } from "react";

import { toast } from "react-toastify";
import * as xlsx from "xlsx";
import {
  _timerDelayClick,
  repositoryMdm,
  repositoryPos,
} from "../../../../_base/_const/_constVar";
import { NotificationExtension } from "../../../../_base/extension/NotificationExtension";
import { _localization } from "../../../../config/location";
import { MessageResponse } from "../../../../model/MessageResponse";
import { TblDMInventory } from "../../../../model/TblDMInventory";
import "../tab.component.css";
import "../../../../Styles/compact-table-head.css";
import CreateDataView from "./CreateDataView";
import DeleteView from "./DeleteView";
import DetailDataView from "./DetailDataView";
import EditDataView from "./EditDataView";
import ImportExcelView from "./ImportExcelView";
import { green } from "../../../../const/variables";
import BreadcrumbLayout1 from "../../../../_base/component/_layout/_breadcrumb";
import { useForm } from "@mantine/form";
import { IconSearch } from "@tabler/icons-react";
import { IconReload } from "@tabler/icons-react";
import { paginationBase } from "../../../../_base/model/_base/BaseTable";
import { Text } from "@mantine/core";
import { SelectListItemModel } from "../../../../model/SelectListItem";
import { BASE_API_DELIVERY } from "../../../../config";
import { getPancakeWarehouses } from "./pancakeWarehouseApi";
import {
  PancakeUpdateTask,
  enqueuePancakeUpdate,
  resumePancakeUpdates,
  subscribePancakeUpdates,
} from "./pancakeUpdateQueue";
import {
  getDistinctAttribute3,
  updateInventoryAttribute3,
} from "./attribute3Api";

type DMInventoryProps = {
  /** Ẩn breadcrumb khi component được nhúng trong tab của màn hình khác */
  hideBreadcrumb?: boolean;
};

const DMInventory = ({ hideBreadcrumb }: DMInventoryProps) => {
  interface SearchCriteria {
    keySearch?: string;
    active?: string;
    branchId: number;
    invCode?: string[];
    attribute3?: string;
  }
  const form = useForm<SearchCriteria>({
    mode: "uncontrolled",
    initialValues: {
      branchId: 0,
    },
  });

  const [pancakeWarehouses, setPancakeWarehouses] = useState<ComboboxItem[]>(
    [],
  );
  const [pancakePending, setPancakePending] = useState<PancakeUpdateTask[]>([]);
  // Giá trị đang chờ lưu theo id kho (lệnh sau ghi đè lệnh trước), hiển thị ngay thay cho giá trị cũ
  const pancakePendingValues = React.useMemo(
    () =>
      new Map(pancakePending.map((x) => [x.inventoryId, x.pancakeWarehouseId])),
    [pancakePending],
  );

  const [attribute3Options, setAttribute3Options] = useState<string[]>([]);
  // Giá trị attribute3 đang lưu theo id kho, hiển thị ngay thay cho giá trị cũ
  const [attribute3Saving, setAttribute3Saving] = useState<
    Map<string, string | null>
  >(new Map());

  const saveAttribute3 = async (
    inventory: TblDMInventory,
    attribute3: string | null,
  ) => {
    setAttribute3Saving((prev) => new Map(prev).set(inventory.id, attribute3));
    let success = false;
    try {
      const res = await updateInventoryAttribute3(inventory.id, attribute3);
      success = !!res?.success;
    } catch (error) {
      console.error(error);
    }
    if (success)
      setData((prev) =>
        prev.map((x) =>
          x.id === inventory.id
            ? { ...x, attribute3: attribute3 ?? undefined }
            : x,
        ),
      );
    else
      NotificationExtension.Fails(
        `Cập nhật Attribute3 thất bại cho kho: ${inventory.code}`,
      );
    setAttribute3Saving((prev) => {
      const next = new Map(prev);
      next.delete(inventory.id);
      return next;
    });
  };

  //#region  table
  const columns = React.useMemo<MRT_ColumnDef<TblDMInventory>[]>(
    () => [
      {
        accessorKey: "branchCode",
        header: "Mã chi nhánh",
      },
      {
        accessorKey: "branchName",
        header: "Tên chi nhánh",
      },
      {
        accessorKey: "branchAsiaCode",
        header: "Mã chi nhánh Asia",
        size: 200,
      },
      {
        accessorKey: "code",
        header: "Mã kho",
        // Cell: ({ renderedCellValue, row }) => (
        //   <Tooltip label="Xem chi tiết">
        //     <Badge
        //       radius="sm"
        //       variant="dot"
        //       size="lg"
        //       style={{ cursor: "pointer" }}
        //       color={renderedCellValue === null ? "red" : green.base}
        //       onDoubleClick={() => detailItem(row.original.id)}
        //     >
        //       {renderedCellValue === null ? null : renderedCellValue}
        //     </Badge>
        //   </Tooltip>
        // ),
      },
      {
        accessorKey: "name",
        header: "Tên kho",
      },
      {
        accessorKey: "attribute7",
        header: "Mã kho Asia",
        size: 175,
      },
      {
        accessorKey: "attribute6",
        header: "Kho Pancake",
        size: 240,
        Cell: ({ row }) => {
          const isSaving = pancakePendingValues.has(row.original.id);
          const value = isSaving
            ? (pancakePendingValues.get(row.original.id) ?? null)
            : (row.original.attribute6 ?? null);
          return (
            // Chặn click lan lên dòng, tránh tick/bỏ tick dòng khi chọn kho
            <Box onClick={(e) => e.stopPropagation()}>
              <Select
                size="xs"
                placeholder="Chọn kho Pancake"
                searchable
                clearable
                allowDeselect={false}
                data={pancakeWarehouses}
                value={value}
                rightSection={isSaving ? <Loader size={14} /> : undefined}
                onChange={(pancakeWarehouseId) =>
                  enqueuePancakeUpdate({
                    inventoryId: row.original.id,
                    inventoryCode: row.original.code,
                    pancakeWarehouseId,
                    previousPancakeWarehouseId: value,
                  })
                }
              />
            </Box>
          );
        },
      },
      {
        accessorKey: "attribute3",
        header: "Thuộc tính",
        size: 200,
        Cell: ({ row }) => {
          const isSaving = attribute3Saving.has(row.original.id);
          const value = isSaving
            ? (attribute3Saving.get(row.original.id) ?? null)
            : row.original.attribute3 || null;
          return (
            // Chặn click lan lên dòng, tránh tick/bỏ tick dòng khi chọn giá trị
            <Box onClick={(e) => e.stopPropagation()}>
              <Select
                size="xs"
                placeholder="Chọn thuộc tính"
                searchable
                clearable
                allowDeselect={false}
                data={attribute3Options}
                value={value}
                // Khoá ô khi đang lưu để không gửi chồng request cho cùng một kho
                disabled={isSaving}
                rightSection={isSaving ? <Loader size={14} /> : undefined}
                onChange={(attribute3) =>
                  saveAttribute3(row.original, attribute3)
                }
              />
            </Box>
          );
        },
      },
      // {
      //   accessorKey: "addr",
      //   header: "Địa chỉ",
      // },
      // {
      //   accessorKey: "phone",
      //   header: "Điện thoại",
      // },
      // {
      //   accessorKey: "fax",
      //   header: "Fax",
      // },
      // {
      //   accessorKey: "email",
      //   header: "Email",
      // },
      // {
      //   accessorKey: "positionId",
      //   header: "Mã vùng",
      // },
      // {
      //   accessorKey: "oldInventoryCode",
      //   header: "kho khác",
      // },
      // {
      //   accessorKey: "codeoracle",
      //   header: "Mã kho ORC",
      // },
      {
        accessorKey: "note",
        header: "Ghi chú",
      },
      {
        accessorKey: "active",
        header: "Sử dụng",
        filterFn: "equals",
        mantineFilterSelectProps: {
          data: [
            { label: "Đang sử dụng", value: "true" },
            { label: "Dừng sử dụng", value: "false" },
          ],
        },
        filterVariant: "select",
        Cell: ({ renderedCellValue, row }) => (
          <>
            <Badge color={getColorStatus(row.original.active ?? false)}>
              {row.original.active ? "Đang sử dụng" : "Dừng sử dụng"}
            </Badge>
          </>
        ),
      },
      {
        accessorKey: "action",
        header: "Thao tác",
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
        enableResizing: false,
        Cell: ({ renderedCellValue, row, table }) => (
          <Box
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <Tooltip label="Chỉnh sửa">
              <ActionIcon
                variant="light"
                aria-label="Settings"
                color="orange"
                onClick={async () => {
                  editItem(row.original.id);
                }}
              >
                <IconEdit size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip>

            <Tooltip label="Chi tiết">
              <ActionIcon
                variant="light"
                aria-label="Settings"
                color="cyan"
                onClick={async () => {
                  detailItem(row.original.id);
                }}
              >
                <IconEye size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip>

            {/* <Tooltip
              label={row.original.active === true ? "Dừng sử dụng" : "Sử dụng"}
            >
              <ActionIcon
                variant="light"
                aria-label="Settings"
                color={row.original.active === true ? "violet" : "green"}
                onClick={async () => {
                  await activesData(!row.original.active, row.original.id);
                }}
              >
                {row.original.active === true ? (
                  <IconHandStop size={20} />
                ) : (
                  <IconActivity size={20} />
                )}
              </ActionIcon>
            </Tooltip> */}

            {/* <Tooltip label="Xóa">
              <ActionIcon
                variant="light"
                aria-label="Settings"
                color="red"
                onClick={async () => {
                  await deleteData([row.original.id]);
                }}
              >
                <IconTrash size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip> */}
          </Box>
        ),
      },
    ],
    [
      pancakeWarehouses,
      pancakePendingValues,
      attribute3Options,
      attribute3Saving,
    ],
  );

  //data and fetching state
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [data, setData] = useState<TblDMInventory[]>([]);
  const [dataTemp, setDataTemp] = useState<TblDMInventory[]>([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [height, setHeight] = useState(0);
  const [pagination, setPagination] = useState(paginationBase);
  //table state
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [dataInvCode, setDataInvCode] = useState<SelectListItemModel[]>([]);
  const [keySearch, setKeySearch] = useState<string>("");
  const [selectIds, setSelectIds] = useState<string[]>([]);
  const [deleteViewStatus, setDeleteViewStatus] = useState(false);
  const [dataBranch, setBranch] = useState<Warehouse[]>([]);
  //count
  const [timeLeft, setTimeLeft] = useState(60);
  const [isCounting, setIsCounting] = useState(false);

  type Warehouse = {
    id: number;
    name: string;
    att1: string | null;
    att2: string | null;
    att3: number;
    att4: number;
    att5: string | null;
    disabled: boolean;
    group: string | null;
    selected: boolean;
    text: string;
    value: string;
  };
  function getColorStatus(text: boolean) {
    switch (text) {
      case true:
        return "teal";
      default:
        return "red";
    }
  }

  const startCountdown = () => {
    if (!isCounting) {
      setTimeLeft(_timerDelayClick);
      setIsCounting(true);
    }
  };

  const loadingWarehouse = async () => {
    try {
      const response = await repositoryMdm.get<MessageResponse<[]>>(
        `/api/v1/SyncData/sync-inventory`,
      );

      if (response && response.data) {
        NotificationExtension.Success("Cập nhật thành công !");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      } else {
        NotificationExtension.Fails("Cập nhật thất bại !");
      }
    } catch (error) {
      NotificationExtension.Warn("Đã xảy ra lỗi trong quá trình cập nhật!");
      console.error(error);
    }
  };

  const handleExport = async () => {
    const search = form.getValues();
    let url = `?Skip=${pagination?.pageIndex * pagination?.pageSize}&Take=${
      pagination.pageSize
    }`;
    if (search.keySearch) {
      url += `&KeySearch=${search.keySearch?.trim()?.toLowerCase()}`;
    }
    if (search.active) {
      url += `&Active=${search.active}`;
    }
    if (search.invCode && search.invCode.length > 0) {
      search.invCode.forEach((invCode) => {
        url += `&InventoryCode=${invCode}`;
      });
    }
    const baseUrl = `/api/v1/ExportExcel/export-inventory${url}`;

    const _url = BASE_API_DELIVERY + baseUrl;
    const token = localStorage.getItem("token");

    const response = await fetch(_url, {
      method: "GET",
      headers: {
        "Content-Type": "application/vnd.ms-excel",
        Authorization: `Bearer ${token?.replace(`"`, "").replace(`"`, "")}`,
      },
    });

    if (!response.ok) {
      throw new Error("Failed to download file");
    }
    const blob = await response.blob();
    const urlss = window.URL.createObjectURL(blob);
    const _name = new Date().toISOString().slice(0, 10);
    let filename = "Danh_muc_kho.xlsx";
    const link = document.createElement("a");
    link.href = urlss;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  };

  const handleOnChange = (e: any) => {
    const value = e.target.value.toLowerCase() ?? "";
    setKeySearch(value);
    if (value) {
      const searchResult = dataTemp.filter(
        (product) =>
          product.name?.toLowerCase().includes(value) ||
          product.code?.toLowerCase().includes(value),
      );
      setRowCount(searchResult.length);
      setSelectIds([]);
      table.resetRowSelection();
      setData(searchResult);
    } else {
      setRowCount(dataTemp.length);
      setSelectIds([]);
      table.resetRowSelection();
      setData(dataTemp);
    }
  };

  const activeData = async (status: boolean) => {
    if (selectIds.length < 1)
      NotificationExtension.Success("Bạn chưa chọn dữ liệu !");
    else
      try {
        const res = await repositoryPos.post<MessageResponse<boolean>>(
          `/api/v1/TblDmInventory/actives`,
          {
            ids: selectIds,
            status: status,
          },
        );
        console.log(res);
        if (res && res.success) {
          NotificationExtension.Success("Cập nhật thành công !");
          await fetchData();
        } else NotificationExtension.Fails("Cập nhật thất bại !");
      } catch (error) {
        console.error(error);
        return;
      }
  };

  const activesData = async (status: boolean, id: string | number) => {
    if (Number(id) < 1)
      NotificationExtension.Success("Bạn chưa chọn dữ liệu !");
    else
      try {
        const res = await repositoryPos.post<MessageResponse<boolean>>(
          `/api/v1/TblDmInventory/actives`,
          { ids: [id], status: status },
        );
        if (res && res.success) {
          NotificationExtension.Success("Cập nhật thành công !");
          setDeleteViewStatus((prev: any) => !prev);
        } else NotificationExtension.Fails("Cập nhật thất bại !");
      } catch (error) {
        console.error(error);
        return;
      }
  };

  const fetchData = async () => {
    const search = form.getValues();
    setIsLoading(true);
    setIsRefetching(true);
    setIsError(false);
    let url = `?Skip=${pagination?.pageIndex * pagination?.pageSize}&Take=${
      pagination.pageSize
    }`;
    if (search.keySearch) {
      url += `&KeySearch=${search.keySearch?.trim()?.toLowerCase()}`;
    }
    if (search.active) {
      url += `&Active=${search.active}`;
    }
    if (search.invCode && search.invCode.length > 0) {
      search.invCode.forEach((invCode) => {
        url += `&InventoryCodes=${invCode}`;
      });
    }
    if (search.branchId) {
      url += `&BranchId=${search.branchId}`;
    }
    if (search.attribute3) {
      url += `&Attribute3=${encodeURIComponent(search.attribute3)}`;
    }
    try {
      const response = await repositoryPos.get<
        MessageResponse<TblDMInventory[]>
      >(`/api/v1/TblDmInventory/get-list${url}`);

      if (response && response.success) {
        let result = response.data;
        setData(result);
        setRowCount(response.totalCount ?? 0);
        table.resetRowSelection();
      } else {
        setData([]);
        setRowCount(0);
      }
    } catch (error) {
      setData([]);
      setRowCount(0);
      setIsError(true);
      console.error(error);
      return;
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
    }
    startCountdown();
  };
  const DataInvCode = async () => {
    try {
      const response = await repositoryPos.get(
        `/api/v1/TblDmInventory/get-all?checkAuth=true`,
      );
      if (response && response.httpStatusCode === 200) {
        const transformedData = response.data
          .filter((i: any) => i.value && i.text)
          .map((item: any) => {
            return {
              value: item.att1,
              label: item.text,
            };
          });

        setDataInvCode(transformedData);
      }
    } catch (error) {
      console.error(error);
      return;
    }
  };
  const DataBranch = async () => {
    try {
      let url = `api/v1/TblDmInventory/get-select-branch`;
      const response = await repositoryPos.get(url);
      console.log(response);
      if (response && response.success) {
        setBranch(response.data);
      }
    } catch (error) {
      console.error(error);
      return;
    }
  };
  useEffect(() => {
    DataBranch();
  }, []);
  useEffect(() => {
    getPancakeWarehouses().then(setPancakeWarehouses);
    getDistinctAttribute3().then(setAttribute3Options);
    const unsubscribe = subscribePancakeUpdates((pending, saved) => {
      // Lưu xong thì ghi giá trị mới vào dòng, để khi bỏ giá trị chờ không bị nháy về giá trị cũ
      if (saved)
        setData((prev) =>
          prev.map((x) =>
            x.id === saved.inventoryId
              ? { ...x, attribute6: saved.pancakeWarehouseId ?? undefined }
              : x,
          ),
        );
      setPancakePending(pending);
    });
    resumePancakeUpdates();
    return unsubscribe;
  }, []);
  const deleteData = async (ids: (string | number)[]) => {
    if (ids.length < 1) NotificationExtension.Warn("Bạn chưa chọn dữ liệu !");
    else
      try {
        modals.openConfirmModal({
          title: (
            <>
              <Title order={5}>Xóa kho!</Title>
            </>
          ),

          centered: true,

          size: "550px",
          children: <DeleteView idItems={ids} fetchData={fetchData} />,
          confirmProps: { display: "none" },
          cancelProps: { display: "none" },
        });
      } catch (error) {
        console.error(error);
        return;
      }
  };

  function createItem() {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Thêm mới kho!</Title>
        </>
      ),
      centered: true,
      size: "auto",
      children: <CreateDataView fetchData={fetchData} />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  }

  function editItem(id: string | number) {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Chỉnh sửa kho!</Title>
        </>
      ),
      centered: true,
      size: "auto",
      children: <EditDataView id={id} fetchData={fetchData} />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  }

  function detailItem(id: string | number) {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Chi tiết kho!</Title>
        </>
      ),
      centered: true,
      size: "auto",
      children: <DetailDataView id={id} />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  }

  function importExcelItem() {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Import excel danh mục kho!</Title>
        </>
      ),
      size: "auto",
      yOffset: "3%",
      children: <ImportExcelView onSuccess={fetchData} />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  }

  useEffect(() => {
    let timer: ReturnType<typeof setInterval>;
    if (isCounting && timeLeft > 0) {
      timer = setInterval(() => {
        setTimeLeft((prevTime) => prevTime - 1);
      }, 1000);
    } else if (timeLeft === 0) {
      setIsCounting(false);
    }
    return () => clearInterval(timer);
  }, [isCounting, timeLeft]);

  useEffect(() => {
    const valuesList = Object.keys(rowSelection);
    setSelectIds(valuesList);
    if (valuesList.length < 1) setSelectIds([]);
    else {
      const valuesList = Object.keys(rowSelection);
      setSelectIds(valuesList);
    }
  }, [rowSelection]);

  useEffect(() => {
    fetchData();
  }, [deleteViewStatus, pagination]);

  useEffect(() => {
    const handleResize = () => {
      const rect = headerRef.current?.getBoundingClientRect();
      const top = rect?.top ?? 0;
      const headerHeight = rect?.height ?? 0;
      // 120 = thanh phân trang + thanh cuộn ngang + padding dưới
      setHeight(Math.max(window.innerHeight - top - headerHeight - 75, 220));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize); // Update height on window resize

    return () => {
      window.removeEventListener("resize", handleResize); // Clean up event listener
    };
  }, []);

  const table = useMantineReactTable({
    columns,
    data,
    enableColumnResizing: true,
    positionToolbarAlertBanner: "bottom",
    //add custom action buttons to top-left of top toolbar

    enableTopToolbar: false,
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,
    enableRowSelection: true,
    getRowId: (row) => row.id,
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["mrt-row-select", "code"],
        right: ["action"],
      },
      columnVisibility: { id: false },
      density: "xs",
    },
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    // manualFiltering: true,
    manualPagination: true,
    // manualSorting: true,
    rowCount,
    // onColumnFiltersChange: setColumnFilters,
    // onGlobalFilterChange: setGlobalFilter,
    onPaginationChange: setPagination,
    // onSortingChange: setSorting,
    mantineTableHeadCellProps: {
      style: {
        padding: "2px 15px",
        fontSize: "12.5px",
        fontWeight: 600,
      },
    },
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        //  fontWeight: row.getIsSelected() ? "bold" : "normal", //conditional styling
        fontWeight: "500", //conditional styling
        fontSize: "12.5px",
        padding: "5px 15px",
      },
    }),
    state: {
      // columnFilters,
      // globalFilter,
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading, //loading for the first time with no data
      //sorting,
      rowSelection,
    },
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["10", "25", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
      className: "compact-table-head",
    },
    columnFilterDisplayMode: "popover",
    mantineTableBodyRowProps: ({ row }) => ({
      onClick: row.getToggleSelectedHandler(),
      sx: { cursor: "pointer" },
    }),
  });
  const renderMultiSelectOptionInvCode: MultiSelectProps["renderOption"] = ({
    option,
  }) => (
    <Group gap="sm">
      <Text>
        {dataInvCode.find((x: any) => x.value === option.value)?.label}
      </Text>
    </Group>
  );
  //#endregion
  return (
    <>
      {hideBreadcrumb ? null : (
        <div
          style={{
            border: "1px solid #dee2e6",
            padding: "0px 10px",
            overflowX: "hidden",
          }}
        >
          <BreadcrumbLayout1></BreadcrumbLayout1>
        </div>
      )}
      <Box
        ref={headerRef}
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          flexWrap: "wrap",
          marginTop: "10px",
          justifyContent: "space-between",
          padding: "10px 0",
        }}
      >
        <Flex
          direction={"row"}
          gap="md"
          align="center"
          justify={"space-between"}
        >
          <Input
            size="sm"
            placeholder="Từ khoá"
            type="text"
            leftSection={<IconSearch color="#15aabf" />}
            key={form.key("keySearch")}
            {...form.getInputProps("keySearch")}
            onKeyDown={async (e) => {
              if (e.key === "Enter") {
                fetchData();
              }
            }}
          />
          {/* <MultiSelect
            key={form.key("invCode")}
            size="sm"
            placeholder="Mã kho"
            searchable
            clearable
            data={dataInvCode.map((x) => x.value)}
            renderOption={renderMultiSelectOptionInvCode}
            leftSection={<IconBuildingWarehouse size={20} color="#15aabf" />}
            onClick={() => {
              if (dataInvCode.length === 0) {
                DataInvCode();
              }
            }}
            {...form.getInputProps("invCode")}
          /> */}
          <Select
            key={form.key("branchId")}
            size="sm"
            placeholder="Chi nhánh"
            searchable
            clearable
            data={dataBranch
              .map((item) => ({
                value: item.value.toString(), // Giá trị của option (bắt buộc phải là string)
                label: `[${item.att2}] ${item.text}`, // Nội dung hiển thị
              }))
              .filter((x) => x.value !== "-1")}
            style={{ flex: 1, maxWidth: "180px" }}
            leftSection={<IconSwitch size={20} color="#15aabf" />}
            {...form.getInputProps("branchId")}
          />
          <Select
            key={form.key("active")}
            size="sm"
            placeholder="Trạng thái"
            searchable
            clearable
            data={[
              { value: "true", label: "Đang sử dụng" },
              { value: "false", label: "Dừng sử dụng" },
            ]}
            style={{ flex: 1, maxWidth: "180px" }}
            leftSection={<IconSwitch size={20} color="#15aabf" />}
            {...form.getInputProps("active")}
          />
          <Select
            key={form.key("attribute3")}
            size="sm"
            placeholder="Thuộc tính"
            searchable
            clearable
            data={attribute3Options}
            style={{ flex: 1, maxWidth: "180px" }}
            leftSection={<IconSwitch size={20} color="#15aabf" />}
            {...form.getInputProps("attribute3")}
          />
          <Button
            type="submit"
            leftSection={<IconSearch size={20} />}
            color="blue"
            variant="outline"
            onClick={async () => {
              // luôn về trang 1 khi tìm kiếm
              if (pagination.pageIndex !== 0) {
                setPagination((prev: any) => ({ ...prev, pageIndex: 0 }));
                return;
              }
              await fetchData();
            }}
          >
            Tìm kiếm
          </Button>{" "}
        </Flex>
        <Flex
          gap="md"
          justify={{ sm: "flex-start", lg: "flex-end" }}
          align="center"
          direction="row"
          wrap="wrap"
        >
          <Button
            leftSection={<IconReload size={14} />}
            color="violet"
            variant="outline"
            onClick={async () => {
              loadingWarehouse();
            }}
          >
            Đồng bộ danh mục kho
          </Button>

          {/* <Button
            leftSection={<IconZoomReset size={14} />}
            color="violet"
            variant="outline"
            onClick={async () => {
              await fetchData();
            }}
            disabled={isCounting}
          >
            {timeLeft > 0 && timeLeft} Load data
          </Button> */}
          <Menu shadow="md" width={200}>
            <Menu.Target>
              <Button
                // size="xs"
                rightSection={
                  <IconCaretDown style={{ width: rem(14), height: rem(14) }} />
                }
              >
                Chức năng
              </Button>
            </Menu.Target>

            <Menu.Dropdown>
              <Menu.Label>Application</Menu.Label>
              <Menu.Item
                leftSection={
                  <IconFileExport style={{ width: rem(14), height: rem(14) }} />
                }
                onClick={handleExport}
              >
                Export Excel
              </Menu.Item>
              <Menu.Item
                leftSection={
                  <IconFileUpload style={{ width: rem(14), height: rem(14) }} />
                }
                onClick={importExcelItem}
              >
                Import Excel
              </Menu.Item>

              <Menu.Item
                leftSection={
                  <IconActivity style={{ width: rem(14), height: rem(14) }} />
                }
                onClick={async () => {
                  await activeData(true);
                }}
                disabled={Number(selectIds) < 1}
              >
                Sử dụng
              </Menu.Item>

              <Menu.Item
                leftSection={
                  <IconHandStop style={{ width: rem(14), height: rem(14) }} />
                }
                onClick={async () => {
                  await activeData(false);
                }}
                disabled={Number(selectIds) < 1}
              >
                Dừng sử dụng
              </Menu.Item>
              <Menu.Item
                leftSection={
                  <IconX style={{ width: rem(14), height: rem(14) }} />
                }
              >
                Đóng
              </Menu.Item>
            </Menu.Dropdown>
          </Menu>
        </Flex>
      </Box>
      <MantineReactTable table={table} />
    </>
  );
};
export default DMInventory;
